import { StickCalculationResult } from "../models/StickCalculationResult";

export function flattenStickResultData(stickResult: StickCalculationResult) {
  const {
    headers,
    onProdDates,
    geologies,
    wellDesigns,
    sampled3DGeos,
    parentChildMetrics,
    xdaCreations
  } = stickResult;

  const flattenHeaders = headers?.map((header) => {
    return {
      Id: header["uniqueId"],
      "Resouce Play": header["resourcePlay"]
    };
  });

  const flattenOnProdDates = Object.entries(onProdDates).map(([key, value]) => ({
    Id: key,
    "On Prod Date": value ? new Date(value) : null
  }));

  const flattenGeologies = geologies?.map((geo) => {
    return {
      Id: geo["uniqueId"],
      Bench: geo["bench"],
      Zone: geo["zone"]
    };
  });

  const flattenWellDesigns = wellDesigns?.map((design) => {
    if (typeof design === "object" && design !== null) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { organizationId, scenarioId, id, ...rest } = design as {
        organizationId?: unknown;
        scenarioId?: unknown;
        id?: string;
        [key: string]: unknown;
      };
      return {
        Id: id,
        ...rest
      };
    }
    return {
      Id: design["id"]
    };
  });

  const flattenSampled3DGeos = sampled3DGeos?.map((sampled) => {
    if (typeof sampled === "object" && sampled !== null) {
      const { uniqueId, ...rest } = sampled as {
        uniqueId?: string;
        [key: string]: unknown;
      };
      return {
        Id: uniqueId,
        ...rest
      };
    }
    return {
      Id: sampled["uniqueId"]
    };
  });

  const flattenParentChildMetrics = parentChildMetrics?.map((metric) => {
    if (typeof metric === "object" && metric !== null) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { updated, parent, children, uniqueId, ...rest } = metric as {
        updated?: unknown;
        parent?: unknown;
        children?: unknown;
        uniqueId?: string;
        [key: string]: unknown;
      };

      return {
        Id: uniqueId,
        ...rest,
        Parent: JSON.stringify(parent),
        Children: JSON.stringify(children)
      };
    }
    return {
      Id: metric["uniqueId"]
    };
  });

  const flattenXda = xdaCreations?.map((xda) => {
    return {
      Id: xda["id"],
      ...(xda["values"] ?? {})
    };
  });

  return {
    Headers: flattenHeaders,
    "On Prod Dates": flattenOnProdDates,
    Geologies: flattenGeologies,
    "Well Designs": flattenWellDesigns,
    "Sampled 3D Geos": flattenSampled3DGeos,
    "Parent Child Metrics": flattenParentChildMetrics,
    xdaCreations: flattenXda
  };
}
